import { panelSagaWatcher } from './containers/Tvpanel/saga';

export const tvPanelModuleSaga = [panelSagaWatcher];
